import Farmaceuta from "./FarmaceutaContainer";

export default Farmaceuta;
